var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawNewsletterSubscriberPlsr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 800,
    viewBox: "0 0 527.087 800",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-650.145 -138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.944,699.813s6.572,18.987,12.414,37.243,33.592,27.75,33.592,27.75l5.112,13.145-15.336,7.3L373.181,774.3s1.461-14.605,1.461-19.717-23.369-48.2-23.369-48.2Z",
    transform: "translate(622.06 147.255)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(1086.285 760.252)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(816.573 525.509)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1030 290)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.341,689.068s-22.638,30.671-27.75,35.783-6.572,24.1-6.572,24.1l8.763,20.447L259.67,779.62l-39.434-39.434,42.355-62.8Z",
    transform: "translate(590.978 141.935)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.236,337.215c-9.031-.726-29.28-83.7-37.317-129.125-.021-.12-.042-.24-.064-.36-20.6,60.036-41.342,118.042-45.512,120.822-8.763,5.844-51.922-30.827-64.334-39.59-11.823-8.347,83.889-160,93.006-174.38,0,0,0-.005,0-.007A230.774,230.774,0,0,0,86.673,86.9C70.608,42.356,98.357,0,98.357,0h38.7a23.023,23.023,0,0,1,23.131,22.442l.967,38.168,5.112,8.766s31.453,234.553,31.453,241.854c0,7.052-29.1,26.058-47.543,26.059Q149.188,337.29,148.236,337.215Z",
    transform: "translate(821.666 570.297)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.422,763.908s0-8.763,2.82-13.136,8.134,15.327,8.134,15.327,32.132,8.763,17.526,18.257-57.691-20.447-70.105-28.48-8.033-17.526-1.461-24.1L230.116,719Z",
    transform: "translate(588.765 151.805)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.671,
    cy: 30.671,
    r: 30.671,
    transform: "translate(900.339 366.836)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.616,349.223c0,4.382-13.467,35.025-13.467,35.025l32.094,7.638V353.668Z",
    transform: "translate(609.459 64.095)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.453,764.235s4.016,1.1-.365-.365-2.921-9.493-2.741-13.576,42.905,9.194,42.905,19.418-54.77,10.224-70.836,8.763-19.717,0-21.908-10.224,6.207-24.464,6.207-24.464Z",
    transform: "translate(625.35 157.685)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.386,167.358c-1.573-1.78-3.238-3.666-5.021-5.628l-.458.043-.529-1.124c-1.905-2.075-3.942-4.227-6.134-6.42-6.429-6.429-18.712,8.24-24.422,8.24a26.565,26.565,0,0,0-10.873,2.475,6.146,6.146,0,0,1-6.294-.743,6.451,6.451,0,0,1-2.39-4.069C6.2,142.473,2.471,93.515.325,68.758A104.348,104.348,0,0,1,11.2,13.489L19.139,2.58A6.232,6.232,0,0,1,26.6.486s24.771,25.7,24.862,26.693c.388,4.26,3.337,13.7,18.7,29.069C86.978,73.064,87.073,87.74,86.7,91.835a8.085,8.085,0,0,0-.037.809,18.072,18.072,0,0,1-.743,5.433c-7.04,22.2-1.528,48.784,7.33,76.532a6.259,6.259,0,0,1-2.524,6.791c-.147.1-.276.185-.388.258l-.016.021a5.98,5.98,0,0,1-4.729,2.526C80.021,184.2,73.072,176.06,65.386,167.358Z",
    transform: "translate(894.102 428.178)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873.606 352.196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.144,336.654l-5.506-6.405c.458,33.729,29.241,63.18,29.241,63.18l-64.541-7.083-1.631-8.947-3.372,7.368-7.88-2.2-2.267-5.455-4.863,2.914,9.978-43.373c9.854-41.377,39.9-35.308,39.9-35.308,41.274-.2,34.673,28.9,34.673,28.9Z",
    transform: "translate(-286.324 -301.034)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.05,538.048,411.9,552.8a14.724,14.724,0,0,1,1.218,23.075h0a14.724,14.724,0,0,1-22.246-3.311L378.806,553.06,336.35,488.9a17.692,17.692,0,0,0,9.933-3.058c4.4-3.236,7.659-9.885,7.659-9.885Z",
    transform: "translate(618.52 94.156)",
    fill: "#ed9da0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawNewsletterSubscriberPlsr);
export default __webpack_public_path__ + "static/media/undraw_newsletter-subscriber_plsr.478c65799a3fde96cd5cdb8745f01f7b.svg";
export { ForwardRef as ReactComponent };